import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { Formik } from 'formik';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import Snackbar from '../../../components/Snackbar';
import { connect } from 'react-redux';
import { phoneNumberValidation } from '../../../utils/validations';
import { firestore } from '../../../configs/environments/firebase/firebaseApp'


const FormPhoneNumber = props => {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <TextField
        id="phoneNumber"
        name="phoneNumber"
        type="text"
        variant="outlined"
        label="Número telefónico"
        placeholder="10 dígitos: 5511223344"
        value={values.phoneNumber}
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={
          touched.phoneNumber && errors.phoneNumber && errors.phoneNumber
        }
        error={touched.phoneNumber && errors.phoneNumber ? true : false}
      />
      <br />
      <ButtonBase type="submit" variant="primary">
        Guardar Cambios
      </ButtonBase>
    </form>
  );
};

const UpdatePhoneNumber = props => {
  const [phoneNumber, setPhoneNumber] = useState('');

  useEffect(() => {
    props.phoneNumber && setPhoneNumber(props.phoneNumber);
  }, [props.phoneNumber]);

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'info'
  });

  const handleUpdatePhoneNumber = (
    { phoneNumber },
    { setSubmitting, setFieldError }
  ) => {
    setSubmitting(false);

    const {
      uid
    } = props;
    firestore.collection("lawyerUsers")
  .doc(uid)
  .update({
    "phone": phoneNumber
  })
      .then(() => {
        setFeedbackMessage({
          open: true,
          message: 'Teléfono actualizado con éxito',
          variant: 'success'
        });
      })
      .catch(error => {
        setFeedbackMessage({
          open: true,
          message: 'Ocurrio un error, no se logro actualizar el teléfono',
          variant: 'error'
        });
        setFieldError('phoneNumber', 'Vuelve a intentar más tarde');
      });
  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'info'
    });
  };

  return (
    <>
      {phoneNumber && (
        <Formik
          initialValues={{ phoneNumber }}
          validationSchema={phoneNumberValidation}
          onSubmit={handleUpdatePhoneNumber}
          render={props => <FormPhoneNumber {...props} />}
        />
      )}

      <Snackbar
        open={feedbackMessage.open}
        variant={feedbackMessage.variant}
        message={feedbackMessage.message}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '8px' : '80px'}
      />
    </>
  );
};

const mapStateToProps = state => ({
  phoneNumber: state.authClient.phone,
  uid: state.authClient.uid
});

export default connect(mapStateToProps)(UpdatePhoneNumber);
